import React from "react";
import styled, { css } from "styled-components";
import { Button as MuiButton } from "@material-ui/core";
import { ButtonProps as MuiButtonProps } from "@material-ui/core/Button";

const StyledMuiButton = styled(MuiButton)`
  && {
    font-family: Inter, system-ui;
    text-transform: none;
    box-shadow: none !important;
    border-radius: 8px;

    ${({ size = "medium" }) =>
      size === "medium" &&
      css`
        font-size: 16px;
        font-weight: 400;
        height: 38px;
      `};

    &:disabled {
      color: #949494;
      background-color: #e8e8e8;
    }

    span.material-icons {
      margin-right: 8px;
      margin-left: -4px;
    }
  }
`;

export interface ButtonProps extends MuiButtonProps {}

const Button = (props: ButtonProps) => (
  <StyledMuiButton {...props}></StyledMuiButton>
);

export default Button;
